import React from 'react';
import { Row, Col } from 'react-bootstrap';
import SuperadminComponent from './Superadmin'; // Import Superadmin Component

const Superadmin = () => {
  return (
    <Row>
      <Col md={12} className="p-4">
        <SuperadminComponent />
      </Col>
    </Row>
  );
};

export default Superadmin;
